import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { CommandIcon } from '../Steps/CommandIcons';
import styles from './screenshot.module.css';

/** kaneai's cursor arrow — quoted from ScreenshotWithCursor.tsx (22×24,
 * dark var(--lt-text-primary), white 1px stroke, soft drop shadow). */
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var CursorSvg = function CursorSvg() {
  return /*#__PURE__*/_jsxs("svg", {
    width: "22",
    height: "24",
    viewBox: "0 0 22 24",
    fill: "none",
    "aria-hidden": "true",
    children: [/*#__PURE__*/_jsxs("g", {
      filter: "url(#ev_cursor_shadow)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M6.08604 19.2174L2.69809 1.95012L18.2537 10.4731L10.5912 12.6961L6.08604 19.2174Z",
        fill: "var(--lt-text-primary)"
      }), /*#__PURE__*/_jsx("path", {
        d: "M6.08604 19.2174L2.69809 1.95012L18.2537 10.4731L10.5912 12.6961L6.08604 19.2174Z",
        stroke: "white"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsxs("filter", {
        id: "ev_cursor_shadow",
        x: "0",
        y: "0",
        width: "21.5508",
        height: "23.4814",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          "in": "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "1"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "1"
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          "in": "SourceGraphic",
          in2: "effect1_dropShadow",
          result: "shape"
        })]
      })
    })]
  });
};
var truncate = function truncate(s, n) {
  return s.length > n ? "".concat(s.slice(0, n), "...") : s;
};
/** Viewport size: environment.resolution when authored, else the
 * screenshot's natural dimensions (the shot IS the viewport — packs
 * without a resolution field still position correctly). */
function viewportOf(resolution, natural) {
  var match = resolution ? /^(\d+)\s*x\s*(\d+)$/i.exec(resolution) : null;
  if (match) {
    var vw = Number(match[1]);
    var vh = Number(match[2]);
    if (vw > 0 && vh > 0) return {
      vw: vw,
      vh: vh
    };
  }
  if (natural && natural.w > 0 && natural.h > 0) {
    return {
      vw: natural.w,
      vh: natural.h
    };
  }
  return null;
}

/** Percentage position from viewport coords. */
export function cursorPointFor(step, resolution) {
  var _step$intent;
  var natural = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  if (!step.cursor) return null;
  // The actions log stamps its own coordinate space (iOS: POINTS, while
  // env resolution is physical px) — it always wins over the env string.
  var vp = step.cursorViewport ? {
    vw: step.cursorViewport.w,
    vh: step.cursorViewport.h
  } : viewportOf(resolution, natural);
  if (!vp) return null;
  var vw = vp.vw,
    vh = vp.vh;
  // (0,0)/(-1,-1) mean "no position" in kaneai — treat as absent.
  if (step.cursor.x <= 0 && step.cursor.y <= 0) return null;
  return {
    leftPct: Math.max(0, Math.min(100, step.cursor.x / vw * 100)),
    topPct: Math.max(0, Math.min(100, step.cursor.y / vh * 100)),
    command: step.command,
    label: (_step$intent = step.intent) !== null && _step$intent !== void 0 ? _step$intent : step.title
  };
}

/**
 * Cursor + purple action pill, ported from ScreenshotWithCursor: 1.4s
 * cubic-bezier travel between steps, idle nudge wobble, pill flips up past
 * 80% height and right-anchors past 70% width.
 */
export function CursorOverlay(_ref) {
  var point = _ref.point;
  var flipY = point.topPct > 80;
  var flipX = point.leftPct > 70;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.cursor,
      style: {
        left: "".concat(point.leftPct, "%"),
        top: "".concat(point.topPct, "%")
      },
      children: /*#__PURE__*/_jsx(CursorSvg, {})
    }), /*#__PURE__*/_jsx("div", {
      className: styles.cursorPillTrack,
      style: _objectSpread({
        top: "".concat(point.topPct, "%"),
        transform: flipY ? 'translateY(calc(-100% - 4px))' : 'translateY(18px)'
      }, flipX ? {
        right: "".concat(100 - point.leftPct, "%"),
        justifyContent: 'flex-end',
        paddingRight: 4
      } : {
        left: "".concat(point.leftPct, "%"),
        paddingLeft: 14
      }),
      children: /*#__PURE__*/_jsxs("div", {
        className: styles.cursorPill,
        children: [/*#__PURE__*/_jsx("span", {
          className: styles.cursorPillIcon,
          children: /*#__PURE__*/_jsx(CommandIcon, {
            command: point.command,
            status: "passed"
          })
        }), /*#__PURE__*/_jsx("span", {
          className: styles.cursorPillText,
          children: truncate(point.label, 40)
        })]
      })
    })]
  });
}
/** Percentage box for step.json element_rect (viewport px). */
export function elementRectFor(step, resolution) {
  var natural = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  if (!step.elementRect) return null;
  var vp = step.cursorViewport ? {
    vw: step.cursorViewport.w,
    vh: step.cursorViewport.h
  } : viewportOf(resolution, natural);
  if (!vp) return null;
  var vw = vp.vw,
    vh = vp.vh;
  var r = step.elementRect;
  if (r.width <= 0 || r.height <= 0) return null;
  return {
    leftPct: Math.max(0, Math.min(100, r.x / vw * 100)),
    topPct: Math.max(0, Math.min(100, r.y / vh * 100)),
    widthPct: Math.max(0, Math.min(100, r.width / vw * 100)),
    heightPct: Math.max(0, Math.min(100, r.height / vh * 100))
  };
}

/** The action target's box — subtle accent outline under the cursor.
 * (New capability from step.json element_rect; no kaneai source to port —
 * the producer's annotated.png draws its own marker.) */
export function ElementRectOverlay(_ref2) {
  var box = _ref2.box;
  return /*#__PURE__*/_jsx("div", {
    "aria-hidden": "true",
    style: {
      position: 'absolute',
      left: "".concat(box.leftPct, "%"),
      top: "".concat(box.topPct, "%"),
      width: "".concat(box.widthPct, "%"),
      height: "".concat(box.heightPct, "%"),
      border: '1.5px solid rgba(9, 105, 218, 0.9)',
      borderRadius: 4,
      boxShadow: '0 0 0 2px rgba(9, 105, 218, 0.15)',
      pointerEvents: 'none'
    }
  });
}